import axiosInstance from "./config";
import { IBranchCreate } from "views/admin/branches/types/branch.interface";

const basePath = `/induk-app/stores`;

export const getBranches = () => {
  return axiosInstance.get(`${basePath}`);
};

export const addBranch = (good: IBranchCreate) => {
  return axiosInstance.post(`${basePath}/create`, good);
};

export const getBranch = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateBranch = (slug: string, good: Partial<IBranchCreate>) => {
  return axiosInstance.patch(`${basePath}/${slug}/update`, good);
};

export const deleteBranch = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/delete`);
};

export const uploadGoodImages = (
  images: File[],
  uploadProgress: React.Dispatch<React.SetStateAction<number>>
) => {
  const formData = new FormData();
  images.forEach((image) => {
    formData.append("images", image);
  });
  return axiosInstance.post(`${basePath}/images-upload`, formData, {
    onUploadProgress(progressEvent) {
      uploadProgress(
        Math.floor((progressEvent.loaded * 100) / progressEvent.total)
      );
    },
  });
};

export const addBranchAdmin = (payload: {
  name: string;
  email: string;
  password: string;
  store_id: number;
}) => {
  return axiosInstance.post(`${basePath}/admins/create`, payload);
};

export const updateBranchAdmin = (
  payload: {
    name: string;
    email: string;
  },
  id: number,
  slug: string
) => {
  return axiosInstance.patch(
    `${basePath}/${slug}/admins/${id}/update`,
    payload
  );
};

export const getBranchAdmins = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}/admins`);
};

export const deleteBranchAdmin = (slug: string, id: number) => {
  return axiosInstance.delete(`${basePath}/${slug}/admins/${id}/delete`);
};

export const moveBranchAdmin = (payload: {
  store_id: number;
  user_id: number;
}) => {
  return axiosInstance.post(`${basePath}/admins/move`, payload);
};

export const getBranchGoods = (
  slug: string,
  page?: number,
  search?: string,
  limit?: number
) => {
  return axiosInstance.get(`${basePath}/${slug}/products`, {
    params: {
      page,
      search,
      limit,
    },
  });
};

export const getProvincesData = () => {
  return axiosInstance.get(`${basePath}/get-provinces`);
};

export const getCitiesData = (provinceId: number) => {
  return axiosInstance.get(`${basePath}/get-cities/${provinceId}`);
};

export const updateBranchGoodStock = (
  storeSlug: string,
  productSlug: string,
  stock: number
) => {
  return axiosInstance.patch(
    `${basePath}/${storeSlug}/products/${productSlug}/stock`,
    { stock }
  );
};
